angular.module('admin')
  .config(['$stateProvider', 'APP_CONFIG', function($stateProvider, APP_CONFIG){

    const clearSession = ['SessionService', function(SessionService){
      return SessionService.clear();
    }];

    $stateProvider.state('login', {
      external: true,
      externalUrl: APP_CONFIG.LOGIN_URL,
      waitForResolve: true,
      url: '/login',
      resolve: {
        clearSession,
      }
    });

    $stateProvider.state('start', {
      url: '/start',
      controller: 'StartCtrl',
      template: `
        <div class="content-main">
          <div class="full-page-notice">
            <div class="full-page-notice__body">
              <div class="section-loader notice">
                <i class="icon icon-ellipsis-h icon-spin"></i>
              </div>
            </div>
          </div>
        </div>
      `,
    });

    $stateProvider.state('logout', {
      external: true,
      externalUrl: APP_CONFIG.LOGOUT_URL,
      waitForResolve: true,
      url: '/logout',
      resolve: {
        clearSession,
      },
    });

    $stateProvider.state('paragonLogin', {
      url: '/paragon-login',
      templateUrl: '/admin/templates/pages/paragon-login.html',
    });

  }]);
